import { render, staticRenderFns } from "./DeptRoleDataruleModal.vue?vue&type=template&id=0c5811a8&scoped=true&"
import script from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js&"
export * from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5811a8",
  null
  
)

export default component.exports